// Zonas horarias IANA seleccionables en contratos. 'Europe/Madrid' es el valor
// por defecto del modelo; el ciclo diario de calendario (lambda /alive y
// /machines/config) la usa para interpretar SleepEnd y para elegir el día de
// precios del calendario en la hora local del parque.
export const CONTRACT_TIMEZONES = [
  { value: 'Europe/Madrid', label: 'España — península (Europe/Madrid)' },
  { value: 'Atlantic/Canary', label: 'España — Canarias (Atlantic/Canary)' },
  { value: 'Europe/Lisbon', label: 'Portugal (Europe/Lisbon)' },
  { value: 'Europe/Paris', label: 'Francia (Europe/Paris)' },
  { value: 'Europe/Rome', label: 'Italia (Europe/Rome)' },
  { value: 'Europe/Berlin', label: 'Alemania (Europe/Berlin)' },
  { value: 'Europe/London', label: 'Reino Unido (Europe/London)' },
  { value: 'Europe/Athens', label: 'Grecia (Europe/Athens)' },
  { value: 'Europe/Istanbul', label: 'Turquía (Europe/Istanbul)' },
  { value: 'Asia/Dubai', label: 'Emiratos Árabes (Asia/Dubai)' },
  { value: 'Asia/Riyadh', label: 'Arabia Saudí (Asia/Riyadh)' },
  { value: 'America/Mexico_City', label: 'México — centro (America/Mexico_City)' },
  { value: 'America/Cancun', label: 'México — Cancún (America/Cancun)' },
  { value: 'America/Bogota', label: 'Colombia (America/Bogota)' },
  { value: 'America/Lima', label: 'Perú (America/Lima)' },
  { value: 'America/Santiago', label: 'Chile (America/Santiago)' },
  { value: 'America/Argentina/Buenos_Aires', label: 'Argentina (Buenos Aires)' },
  { value: 'America/New_York', label: 'EE. UU. — este (America/New_York)' },
  { value: 'America/Los_Angeles', label: 'EE. UU. — oeste (America/Los_Angeles)' },
  { value: 'Asia/Singapore', label: 'Singapur (Asia/Singapore)' },
  { value: 'Australia/Sydney', label: 'Australia — este (Australia/Sydney)' }
]
